import React from 'react';

import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <path fillRule="evenodd" clipRule="evenodd" d="M20.878 19.08c.53-.015.96-.431.977-.947.075-2.32.1-4.65.078-6.976-.005-.536-.456-.967-1.006-.967H4.954c-.55 0-1.002.431-1.006.966-.02 2.327.003 4.657.078 6.976.016.516.446.932.977.948a292.415 292.415 0 0015.875 0zm2.427-15.947c.782.03 1.418.66 1.453 1.441.243 5.408.243 10.574 0 15.98a1.517 1.517 0 01-1.453 1.443 277.734 277.734 0 01-20.729 0 1.517 1.517 0 01-1.453-1.442 175.235 175.235 0 010-15.98 1.516 1.516 0 011.453-1.442c1.204-.046 2.16-.074 3.364-.104V1.69a1.5 1.5 0 013 0v1.284c1.167-.015 6.834-.015 8 0V1.69a1.5 1.5 0 013 0v1.34c1.205.03 2.16.058 3.365.104zM16.941 14.19h1a1 1 0 011 1v1a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1a1 1 0 011-1z" />,
  'Calendar',
  { viewBox: '0 0 24 22' },
);
